import React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

const ArrowUpXS = createSvgIcon(
  <path d="M1 5.96 2.048 7 6 3.08 9.952 7 11 5.96 6 1 1 5.96Z" />,
  'ArrowUpXS'
);

export { ArrowUpXS };